import React, { Component } from "react";
import RenderComponent from './RenderComponent';
import AWSModal from "../common/AWSModal/AWSModal";
import * as tagNameConstant from '../../constants/tagNameConstant';
import * as roleNames from '../../constants/roleNames.const';
import _ from 'underscore';

class DynamicRendercomponent extends Component {

    state = {
        isExpand: false,
        summaryData: {},
        termEndDate: "",
        termLength: "",
        stage: 0,
        alertMessage: "Please attach existing CloudFront PPA",
        payerId: "",
        triggeredNext: false,
        visible: false,
        updateDate: '',
        dataModel: {
            dealIntakeRequestForm: { stage: [] },
        }
    };

    constructor(props) {
        super(props);
        this.myRef = React.createRef()
    }

    /**
     * this function will take question block element and make value of question (selected or written) empty when question is hidden of block
     * @params {*} questionBlockelement
     */
    emptyHiddenFieldOfBlockElement = (questionBlockElement) => {
        questionBlockElement && questionBlockElement.rows.map((questionRow, questionRowindex) => {
            questionRow && questionRow.questions.map((question, questionIndex) => {
                if (question && (question.questionType === "TABLE" || question.questionType === "RATETABLE")) {
                    if (question.tableObj.rows.length && question.tableObj.rows.length > 1) {
                        question.tableObj.rows.splice(1, question.tableObj.rows.length)
                    }
                }
            })
        })
    }

    /**
     * this function will empty the question field when it is hidden
     * @params(rowQuestion)
     */
    emptyHiddenFieldOfQuestion = (rowQuestion) => {
        if (rowQuestion.queType !== "FILEINPUT" && rowQuestion.queType !== "RADIOBUTTON" && rowQuestion.queType !== "BUTTONRADIO") {
            if (rowQuestion.answer) {
                rowQuestion.answer.answerValue = null
            }
        }
    }

    /**
     * this function is used to handle dependent question to make it visible or hidden based on value and question's option
     */
    handleDependendQuestion = (value, question, questionBlockIndex, rowId, id, termEndDate, dateValue) => {
        _.each(question.dependentOn, (dep, index) => {
            if (dep.event === "On Select") {
                if (dep.option.includes(value)) {
                    if (document.getElementById(`${dep.dependentId}`)) { document.getElementById(`${dep.dependentId}`).style.display = "block" }

                    this.props.dataModel.map((stage, stageIndex) => {
                        stage.queBlock.map((questionBlockElement, questionBlockElementIndex) => {
                            if (questionBlockElement !== null) {
                                if (dep.dependentId === questionBlockElement.queBlkId) {
                                    questionBlockElement.isVisible = true;
                                }
                            }
                        })
                    })

                    this.props.dataModel[this.props.stage].queBlock[questionBlockIndex].rows.map((rowsOfQuestion, rowQuestionIndex) => {
                        rowsOfQuestion && rowsOfQuestion.questions.map((rowQuestion, rowQuestionIndex) => {
                            if (rowQuestion !== null) {
                                if (dep.dependentId === rowQuestion.queId) {
                                    rowQuestion.isVisible = true;
                                }
                            }
                        })
                    })
                }
            }
            else if (dep.event === "Off Select") {
                if (!dep.option.includes(value)) {
                    if (document.getElementById(`${dep.dependentId}`)) { document.getElementById(`${dep.dependentId}`).style.display = "none" }

                    this.props.dataModel.map((stage, stageIndex) => {
                        stage.queBlock.map((questionBlockElement, questionBlockElementIndex) => {
                            if (questionBlockElement !== null) {
                                if (dep.dependentId === questionBlockElement.queBlkId) {
                                    this.emptyHiddenFieldOfBlockElement(questionBlockElement)
                                    questionBlockElement.isVisible = false;
                                }
                            }
                        })
                    })

                    this.props.dataModel[this.props.stage].queBlock[questionBlockIndex].rows.map((rowsOfQuestion, rowQuestionIndex) => {
                        rowsOfQuestion && rowsOfQuestion.questions.map((rowQuestion, rowQuestionIndex) => {
                            if (rowQuestion !== null) {
                                if (dep.dependentId === rowQuestion.queId && rowQuestion.tagName !== tagNameConstant.currentDiscountTermEndCalTag) {
                                    this.emptyHiddenFieldOfQuestion(rowQuestion)
                                    rowQuestion.isVisible = false;
                                }
                            }
                        })
                    })
                }
            }
        })
        this.props.handleOnSelect(value, question, questionBlockIndex, rowId, id, termEndDate, dateValue)
    }

    /**
     * this function will handle dependent validation based on selection and make alert message to be visible or hidden,
     * It will call dependent question function
     */
    handleDependenValidation = (value, question, questionBlockIndex, rowId, id, termEndDate, dateValue) => {

        let count = 0;
        if (question.hasOwnProperty("dependentOn")) {
            _.each(question.dependentOn, (dep, index) => {
                if (dep.event === "checkForAttach") {
                    if (value === dep.option) {
                        _.each(this.props.dataModel[this.props.stage - 1].queBlock, (questionBlockElement, questionBlockElementIndex) => {
                            questionBlockElement && questionBlockElement.rows.map((questionBlock, questionIndex) => {
                                questionBlock && questionBlock.questions.map((questionWithAnswer, indexAnswer) => {
                                    if (questionWithAnswer !== null) {
                                        if (questionWithAnswer.queId === dep.dependentId) {
                                            if (questionWithAnswer.answer.answerValue === null) {
                                                count++;
                                                this.setState({
                                                    alertMessage: dep.alertMessage
                                                })
                                            }
                                        }
                                    }
                                })

                            })
                        })
                    }
                }
                if (dep.event === "showpopup") {
                    if (dep.option.includes(value)) {
                        this.setState({
                            alertMessage: dep.alertMessage
                        })
                    }
                }
            })

            if (count === 0) {
                this.handleDependendQuestion(value, question, questionBlockIndex, rowId, id, termEndDate, dateValue)
                this.props.handleOnSelect(value, question, questionBlockIndex, rowId, id, termEndDate, dateValue)
            }
        } else {
            this.props.handleOnSelect(value, question, questionBlockIndex, rowId, id, termEndDate, dateValue)
        }

    }

    /**
     * This function will call handle change fucniton in Form file to set value to answer object,
     * It will call function which is used to handle validation dependency
     */
    handleOnSelect = (value, question, questionBlockIndex, rowId, id, term, dateValue) => {
        this.overRidePopupModal(value, question)
        let termEndDate = this.state.termEndDate;
        let newdateValue = dateValue;
        this.handleDependenValidation(value, question, questionBlockIndex, rowId, id, termEndDate, newdateValue)
    }

    /**
     * This function will call handle change fucniton in Form file to set value to answer object,
     * It will call function which is used to handle validation dependency
     */
    handleChange = (value, question, questionBlockIndex, rowId, id) => {
        this.overRidePopupModal(value, question)
        let termEndDate = this.state.termEndDate;
        this.props.handleChange(value, question, questionBlockIndex, rowId, id, termEndDate);
        this.handleDependenValidation(value, question, questionBlockIndex, rowId, id, termEndDate)
    }

    /**
     * this function will call showModal function to show popup modal based on question tagname,comparing previos,
     * current value change and user role
     * @param {String} value 
     * @param {Object} question 
     */
    overRidePopupModal = (value, question) => {
        const { userRole } = this.props;
        const userRoleForAlert = roleNames.PRIVATE_PRICING_USERS;
        if (userRoleForAlert.includes(userRole)) {
            const prevQuestionValue = question.answer.answerValue
            if (question.tagName === tagNameConstant.discountTermDateTag) {
                if (value && prevQuestionValue && value !== prevQuestionValue) {
                    this.showModal(true)
                }
            } else if (question.tagName === tagNameConstant.termLengthTag) {
                if (value && prevQuestionValue && value.toString() !== prevQuestionValue.toString() && value.toString() !== this.props.termLength.toString()) {
                    this.showModal(true)
                }
            }
        }
    }

    /**
     * this function will make modal visible
     */
    showModal = (modalState) => {
        this.setState({
            visible: modalState
        })
    }

    handleCancel = () => {
        this.showModal(false)
        this.props.onCancelOfOverrideChanges()
    }

    /**
     * this function will handle ok of Modal
     */
    handleOk = () => this.showModal(false)

    render() {
        let { questionValue, index, questionBlockIndex, triggeredNext, duplicateValidation, duplicateErrFlag, canEditPPR, additionalApprovalFlag, dealStatus,locationStateUser } = this.props;

        return (
            <div className="">
                <AWSModal
                    type="privatePricingEdit"
                    visible={this.state.visible}
                    handleOk={() => { this.handleOk() }}
                    handleCancel={() => { this.handleCancel() }}
                    titleMessage="This will override current data, are you sure you want to continue?"
                />
                <RenderComponent
                    dealStatus={dealStatus}
                    dealInfo={this.props.dealInfo}
                    locationStateUser={locationStateUser}
                    additionalApprovalFlag={additionalApprovalFlag}
                    questionValue={questionValue}
                    index={index}
                    pprId={this.props.pprId}
                    questionBlockIndex={questionBlockIndex}
                    triggeredNext={triggeredNext}
                    onChangeAdditionalApproval={(key, value) => this.props.onChangeAdditionalApproval(key, value)}
                    handleChange={(val, questionValue, questionBlockIndex, rowId, cellIndex) => this.handleChange(val, questionValue, questionBlockIndex, rowId, cellIndex)}
                    handleOnSelect={(val, questionValue, questionBlockIndex, rowId, cellIndex, term, dateValue) => this.handleOnSelect(val, questionValue, questionBlockIndex, rowId, cellIndex, term, dateValue)}
                    onDropdownSelection={this.props.onDropdownSelection}
                    date={this.props.date}
                    termLength={this.props.termLength}
                    dataModel={this.props.dataModel}
                    duplicateValidation={duplicateValidation}
                    userRole={this.props.userRole}
                    handleDeleteTableRow={(rowId) => { this.props.handleDeleteTableRow(rowId) }}
                    handleBulkDeleteTableRow={(rowId) => { this.props.handleBulkDeleteTableRow(rowId) }}
                    duplicateErrFlag={duplicateErrFlag}
                    dynamicSalesManagerOptions={this.props.dynamicSalesManagerOptions}
                    canEditPPR={canEditPPR}
                    handleAffiliatedPayerIdForSummary={this.props.handleAffiliatedPayerIdForSummary}
                />
            </div>
        )
    }
}

export default DynamicRendercomponent;
